/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_Example_Status_3Inputs */

const en_mk_tb_example_status_3 = /** @type {(inputs: Mk_Tb_Example_Status_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blocked`)
};

const id_mk_tb_example_status_3 = /** @type {(inputs: Mk_Tb_Example_Status_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terhambat`)
};

/**
* | output |
* | --- |
* | "Blocked" |
*
* @param {Mk_Tb_Example_Status_3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_example_status_3 = /** @type {((inputs?: Mk_Tb_Example_Status_3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_Example_Status_3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_example_status_3(inputs)
	return en_mk_tb_example_status_3(inputs)
});